const Share = {
  open: async (options = {}) => {
    const title = options.title || 'Ludo Voice';
    const text = options.message || options.text || '';
    const url =
      options.url && typeof options.url === 'string' && options.url.startsWith('http')
        ? options.url
        : typeof window !== 'undefined'
        ? window.location.href
        : '';
    const fullText = text && url && !text.includes(url) ? `${text}\n${url}` : text || url;

    if (typeof navigator !== 'undefined' && navigator.share) {
      try {
        const shareData = { title };
        if (text) shareData.text = text;
        if (url) shareData.url = url;
        await navigator.share(shareData);
        return { success: true, message: 'OK' };
      } catch (err) {
        if (err && err.name === 'AbortError') {
          return { success: false, dismissed: true };
        }
      }
    }

    if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(fullText);
        if (typeof window !== 'undefined' && window.alert) {
          window.alert('Share link & text copied to clipboard!');
        }
        return { success: true };
      } catch (e) {
        console.error('Clipboard copy failed:', e);
      }
    }
    return { success: true };
  },
  share: async (options = {}) => {
    return Share.open(options);
  },
  shareSingle: async (options = {}) => {
    return Share.open(options);
  },
  isPackageInstalled: async () => false,
};

module.exports = Share;
module.exports.default = Share;

